var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRecorder = function SvgRecorder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "23px",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ba63c6",
    className: "cls-1",
    d: "M16,22a8,8,0,0,0,8-8V8A8,8,0,0,0,8,8v6A8,8,0,0,0,16,22ZM12,8a4,4,0,0,1,8,0v6a4,4,0,0,1-8,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ba63c6",
    className: "cls-1",
    d: "M26.85,17.19a2,2,0,0,0-2.66.95A8.55,8.55,0,0,1,16.5,23h-1a8.55,8.55,0,0,1-7.69-4.86A2,2,0,0,0,4.2,19.85a12.57,12.57,0,0,0,9.8,7V30a2,2,0,0,0,4,0V26.9a12.57,12.57,0,0,0,9.8-7A2,2,0,0,0,26.85,17.19Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRecorder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/recorder.ace2dfd9.svg";
export { ForwardRef as ReactComponent };